export { default as ProductTile } from './productTile'
export * from './colorPicker'
export * from './quickAdd'
export * from './productPrice'



// WEBPACK FOOTER //
// ./src/modules/productTile/index.js